import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import getMiddlewareSocketInstance from './common/SocketMiddleware';
import api from './api';

const apiCaller = getApiInstance();

function getNewProduct(env, homeId, productType, productIdentifier) {
    return apiCaller
        .call(api.getNewProductsDetails(env, homeId, productType, productIdentifier))
        .then(({ data }) => {
            if (!data.success) {
                throw new Error('PRODUCT_NOT_FOUND');
            }
            return data;
        })
        .catch(error => {
            Logger.log('dataActions: setNewProductsDetails - ', error);
            throw error;
        });
}

export function initEnvironment(env) {
    return (dispatch, getState) => {
        return apiCaller
            .call(api.initEnvironment(env))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}_GIT__SET_GROUPID`,
                        groupId: data.groupId
                    });
                    dispatch({
                        type: `${env.toUpperCase()}_GIT__SET_ASSIGNEEIDS`,
                        assigneeIds: data.assigneeIds
                    });
                    dispatch({
                        type: `${env.toUpperCase()}_SET_CLIENTINTERFACE`,
                        clientInterface: data.clientInterface
                    });
                    if (data.homes) {
                        dispatch({
                            type: `${env.toUpperCase()}__SET_HOMES`,
                            homes: data.homes
                        });
                    } else throw 'general.error.data_has_not_correctly_returned_by_server';

                    if (data.boxes) {
                        dispatch({
                            type: `${env.toUpperCase()}__SET_BOXES`,
                            boxes: data.boxes
                        });
                    } else throw 'general.error.data_has_not_correctly_returned_by_server';
                    if (data.brands) {
                        dispatch({
                            type: `${env.toUpperCase()}__SET_BRANDS`,
                            brands: data.brands
                        });
                    } else throw 'general.error.data_has_not_correctly_returned_by_server';
                    if (data.managements) {
                        dispatch({
                            type: `${env.toUpperCase()}__SET_MANAGEMENTS`,
                            managements: data.managements
                        });
                    } else throw 'general.error.data_has_not_correctly_returned_by_server';
                    if (data.prefixCenter) {
                        dispatch({
                            type: `${env.toUpperCase()}__SET_PREFIX_CENTER`,
                            prefixCenter: data.prefixCenter
                        });
                    } else throw 'general.error.data_has_not_correctly_returned_by_server';
                    if (data.enums) {
                        dispatch({
                            type: `${env.toUpperCase()}_SET_ENUMS`,
                            enums: data.enums
                        });
                    } else throw 'general.error.data_has_not_correctly_returned_by_server';

                    let access_token = localStorage.getItem('access_token');
                    if (access_token) access_token = access_token.replace(/"/g, '');

                    /** Middleware Connection **/
                    if (typeof data.middlewaresConfig !== 'undefined') {
                        const middleware = getMiddlewareSocketInstance(env, dispatch, getState, access_token, data.middlewaresConfig);

                        middleware.on('newProduct', (homeId, productType, productIdentifier) => {
                            const productKey = `${homeId}_${productType}_${productIdentifier}`;
                            getNewProduct(env, homeId, productType, productIdentifier)
                                .then(data => {
                                    dispatch({
                                        type: `${env.toUpperCase()}__SET_NEW_PRODUCT_DETAILS`,
                                        product: data.productDetails
                                    });
                                    middleware.emit(`newProductFound${homeId}`, {
                                        product: data.productDetails[productKey]
                                    });
                                })
                                .catch(() => Logger.debug(`Le produit ${productKey} n'a pas été trouvé dans la BDD`));
                        });
                    }
                }
                return data;
            })
            .catch(error => {
                Logger.error('dataActions: initEnvironment - ', error);
                throw error;
            });
    };
}

export function disconnectEnvironment() {
    return dispatch => {
        const middlewareInstance = getMiddlewareSocketInstance();
        if (middlewareInstance) middlewareInstance.destroy();
        dispatch({
            type: 'RESET_STORE'
        });
    };
}



// WEBPACK FOOTER //
// ./environments/genericEnv/actions.js